import { render, staticRenderFns } from "./prefecturesOverview.vue?vue&type=template&id=882d8182&scoped=true&"
import script from "./prefecturesOverview.vue?vue&type=script&lang=js&"
export * from "./prefecturesOverview.vue?vue&type=script&lang=js&"
import style0 from "./prefecturesOverview.vue?vue&type=style&index=0&id=882d8182&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882d8182",
  null
  
)

export default component.exports